import styled from "styled-components";

export const StyledMessagePage = styled.div`
  height: 100vh;
  width: 100vw;
  display: flex;
  justify-content: center;
  align-items: center;
  overflow: hidden;
  font-family: ${(props: any) => props.fontFamily};
  .container {
    position: absolute;
    bottom: 50%;
    width: 100%;
    transform: translateY(75px);
    display: flex;
    flex-direction: column;
    align-items: center;
    text-align: center;
    padding: 0 20px;
    margin: 0;
    h1 {
      margin: auto;
      max-width: 300px;
      background: linear-gradient(
        180deg,
        ${(props: any) => props.headerColorOne} 0%,
        ${(props: any) => props.headerColorTwo} 100%
      );
      -webkit-background-clip: text;
      -webkit-text-fill-color: transparent;
      -webkit-text-stroke-width: 1px;
      -webkit-text-stroke-color: #693510;
    }
    h2 {
      max-width: 450px;
      margin: 20px 0;
    }
    .coinsAnimation {
      position: absolute;
      width: 1024px;
      top: -250px;
    }
  }
` as any;
